<script>
    export let onClick = () => false;
    export let text = '';
    export let isCenter = false;
</script>

<div class="card__btn-wrapper">
    <div class="card__btn-shadow" />
    <div class={`card__btn ${text.length < 21 || isCenter ? 'center' : ''}`} on:click={onClick}>{text}</div>
</div>
